"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAgoraVideoDeviceListeners = void 0;
var _setupDeviceListeners = require("@cvent/studio-agora/events/setupDeviceListeners");
var _actions = require("../actions");
/**
 * Sets up listeners for Agora video device changes and dispatches appropriate actions to update the Redux store.
 * @param videoInput
 * @param dispatch
 * @param attendeeId
 */
var updateAgoraVideoDeviceListeners = exports.updateAgoraVideoDeviceListeners = function updateAgoraVideoDeviceListeners(videoInput, dispatch, attendeeId) {
  var videoActions = {
    showNotification: _actions.showNotification,
    addToAttendeeTiles: _actions.addToAttendeeTiles,
    setAttendeeCameraStatus: _actions.setAttendeeCameraStatus,
    setVideoInputDevice: _actions.setVideoInputDevice
  };
  (0, _setupDeviceListeners.clearVideoDeviceListeners)();
  (0, _setupDeviceListeners.setupVideoDeviceListeners)(videoInput, dispatch, videoActions, attendeeId);
};